<div class="page-wrapper">
  <div class="auth-card">

    <!-- Card Header -->
    <div class="card-header-block">
      <img src="logo-login.svg" alt="aInstitute Logo" class="card-logo" />
      <div class="step-badge">Step 1 of 4</div>
    </div>

    <div class="card-body-block">
      <div class="heading-group">
        <h1 class="page-title">Verify Executive Code</h1>
        <p class="page-subtitle">
          Enter the 6-digit executive code provided by your onboarding representative
          to begin the institution setup.
        </p>
      </div>

      <form [formGroup]="registerForm" (ngSubmit)="submit()" novalidate>

        <div class="field-group">
          <label class="field-label" for="executiveCode">Executive Code</label>
          <div class="code-input-wrapper">
            <svg class="field-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <input
              id="executiveCode"
              class="field-input code-input"
              formControlName="executiveCode"
              placeholder="e.g. 482901"
              maxlength="6"
              autocomplete="off"
              [class.is-invalid]="registerForm.controls['executiveCode'].invalid && registerForm.controls['executiveCode'].touched"
            />
          </div>

          <div
            class="field-error"
            *ngIf="registerForm.controls['executiveCode'].invalid && registerForm.controls['executiveCode'].touched">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
              <path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            Please enter a valid 6-digit executive code.
          </div>

          <div class="field-error" *ngIf="verifyError">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
              <path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            {{ verifyError }}
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-submit" [disabled]="registerForm.invalid || isVerifying">
            <span *ngIf="!isVerifying">
              Verify & Continue
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <span *ngIf="isVerifying">Verifying…</span>
          </button>
          <a routerLink="/landing" class="btn-reset">Back to Home</a>
        </div>
      </form>
    </div>

  </div>
</div>
